module.exports = __webpack_public_path__ + "images/702318ede84012dc84a5e4abbea3ecb3.jpg";